import Schema from 'AppReact/schema';
import { orderEvent } from 'types';

export default {
  order_event: Schema(orderEvent, 'object', { defaultValue: {} }),
  inspectionId: Schema('integer', 'primitive-nullable', { defaultValue: null })
};
